import { useMediaLibFetchFiles } from "@editor/modules/media-lib";
import { useMediaLibPanelStoreShallow } from "../stores";

export const useMediaLibPanelFetchFiles = () => {
  const data = useMediaLibPanelStoreShallow((s) => ({
    searchQuery: s.searchQuery,
    willLoadFiles: s.willLoadFiles,
    setWillLoadFiles: s.setWillLoadFiles,
    selectedFolderId: s.selectedFolderId,
    category: s.category,
    amtOfFiles: s.files.length,
    setFiles: s.setFiles,
  }));
  return useMediaLibFetchFiles(data);
};
